import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/checkbox.css';
/* CKEditor 5 theme and editor layout - required for toolbar/buttons to look correct.
   Package exports map "./*" to "./dist/*", so use ckeditor5/<name>.css not ckeditor5/dist/<name>.css */
import 'ckeditor5/ckeditor5.css';
import 'ckeditor5/ckeditor5-editor.css';
import 'ckeditor5/ckeditor5-content.css';
import App from './App';

try {
  const v = localStorage.getItem('appTextSize');
  const val = v !== null && v !== '' ? v : '1';
  document.documentElement.style.setProperty('--app-text-size', val);
} catch (_) {}
document.documentElement.setAttribute('data-theme', 'light');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
